import { call, put } from 'redux-saga/effects';
import { first, sortBy } from 'lodash';
import { get3NDFLDrafts } from 'modules/Taps/services/API';
import {
  getParentDeclarationByYearFailure,
  getParentDeclarationByYearSuccess,
} from 'modules/Taps/components/NDFL3Light/redux/actions';

export default function* getParentDeclarationByYearSaga({ payload: { reportYear } }) {
  const { isOk, data, error } = yield call(get3NDFLDrafts, {
    year: reportYear,
    scope: 'refinement',
  });
  const declaration = first(sortBy(data, ['-dateUpdated', '-dateCreated']));

  if (isOk && declaration) {
    yield put(getParentDeclarationByYearSuccess(declaration));
  } else {
    yield put(getParentDeclarationByYearFailure(error));
  }
}
